import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MuiCircularProgress from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/CircularProgress';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';


const useStyles = buildUseStyles('CircularProgress', () => ({
  root: {
    position: 'relative',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
  },
  textContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
  },
  text: {},
}));

const CircularProgress = ({
  className,
  visible,
  ProgressProps,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const { value } = ProgressProps;

  if (!visible) {
    return null;
  }

  return (
    <Box className={classNames(className, classes.root)}>
      <MuiCircularProgress {...ProgressProps} />
      <Box className={classes.textContainer}>
        <Typography variant="body2" component="div" color="textSecondary">
          {`${Math.round(value)}%`}
        </Typography>
      </Box>
    </Box>
  );
};

CircularProgress.defaultProps = {
  className: '',
  visible: false,
};

CircularProgress.propTypes = {
  className: PropTypes.string,
  visible: PropTypes.bool,
  ProgressProps: PropTypes.object.isRequired,
};

export { CircularProgress };
